export enum EKiwidPlanProductType {
    SOFTWARE = 0,
    MASTER = 1,
    MODULE_NF= 2,
}

export enum EKiwidPlanProductChargeType {
    ONE_TIME = 'one_time',
    RECURRENT = 'recurrent'
}

export enum EKiwidPlanFrequencyType {
    MONTHLY = 'monthly',
    YEARLY = 'yearly'
}

export enum EKiwidPlanStartAction {
    UPGRADE = 'upgrade',
    DOWNGRADE = 'downgrade'
}

export enum EKiwidPlanSoftwareLevel {
    BASIC = 1,
    ESSENTIAL = 2,
    PRO = 3
}

export enum EKiwidPlanItemChangeStatus {
    NONE = 0,
    IMMEDIATE = 1,
    WAITING = 2,
    CANCEL = 3
}
